import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'exa-buildings',
  template: `<router-outlet></router-outlet>`,
  styles: [],
})
export class BuildingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
